import { render, staticRenderFns } from "./Certlist.vue?vue&type=template&id=2e1292a2&scoped=true"
import script from "./Certlist.vue?vue&type=script&lang=js"
export * from "./Certlist.vue?vue&type=script&lang=js"
import style0 from "./Certlist.vue?vue&type=style&index=0&id=2e1292a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1292a2",
  null
  
)

export default component.exports